import Vue from 'vue'
import '@babel/polyfill'
import 'mutationobserver-shim'
import App from './App.vue'
import router from './router'
import store from './store'
import Raphael from 'raphael/raphael'
import './plugins'
import './registerServiceWorker'
import i18n from './i18n'
import axios from './axios'
import * as XLSX from 'xlsx'

import wysiwyg from 'vue-wysiwyg'
require('vue-wysiwyg/dist/vueWysiwyg.css')
global.Raphael = Raphael
Vue.config.productionTip = false
window._ = require('lodash')
Vue.use(wysiwyg, {
  hideModules: { 'image': true }
})

window.XLSX = XLSX

Vue.mixin({
  methods: {
    findMenuPermission (lv = 1, output = 'export', menuId = 1, subMenuId = null, tabMenuId = null) {
      const profile = this.$store.state.auth.profile || this.$store.state.Auth.profile
      const menus = profile?.menu || []
      let foundMenu = {}

      const menu = menus.find(menu => String(menu.menuId) === String(menuId))

      switch (lv) {
        case 1:
          foundMenu = menus.find(menu => String(menu.menuId) === String(menuId))
          break

        case 2:
          foundMenu = menu.child.find(subMenu => String(subMenu.menuId) === String(subMenuId))
          break

        default:
          const subMenu = menu.child.find(subMenu => String(subMenu.menuId) === String(subMenuId))
          foundMenu = subMenu.child.find(tabMenu => String(tabMenu.menuId) === String(tabMenuId))
          break
      }

      if (foundMenu && output === 'childs') {
        return foundMenu.child
      }

      return foundMenu[output]
    },
    findMenuPermissionLv2ByIndex (output = 'export', menuId = 1, subMenuIndex = 0) {
      const profile = this.$store.state.auth.profile || this.$store.state.Auth.profile
      const menus = profile?.menu || []
      const menu = menus.find(m => String(m.menuId) === String(menuId))

      return menu.child[subMenuIndex][output]
    }
  }
})

let vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.vm = vm
window.axios = axios
